export const withDisplayName = (Component, displayName) =>
	Object.assign(Component, { displayName })

export const getDisplayName = (Component) =>
	Component.displayName || Component.name || 'Component'
